import { Link } from "react-router-dom"
import { contactPath } from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { SiteHeader } from "~/layouts/site-header"

const FAQS: Array<{ q: string; a: React.ReactNode }> = [
  {
    q: "Do I need an account to scan a puzzle?",
    a: "No. Anyone can scan a QR sticker and read the puzzle's journey page. You only need to sign in (with an email magic link) to register a puzzle or log a journey.",
  },
  {
    q: "How is my privacy handled?",
    a: "Logged-out visitors never see email addresses or last names. Authenticated users only see other people's first names, or 'Anonymous' if the author chose that on their log. You can also set 'Always anonymous' as a default in your profile.",
  },
  {
    q: "Where do I print stickers?",
    a: "After registering a puzzle, the label page shows a printable preview. You can save it as a PNG, print it directly to letter paper, or print to PDF from your browser. We're working on Avery 5160 sticker-sheet support.",
  },
  {
    q: "What if a puzzle gets damaged or lost?",
    a: "Use the 'Report an issue' link on the puzzle's page. The form prefills the puzzle ID so we can take a look.",
  },
  {
    q: "Can I delete my account?",
    a: "Yes. From your profile settings, click 'Delete my account'. Your past logs stay on the puzzles' pages so the journey isn't broken, but they're attributed to 'Anonymous' from then on.",
  },
  {
    q: "Where can I follow updates?",
    a: (
      <>
        For now, just the{" "}
        <Link to={contactPath({})} className="text-blue-600 underline">
          contact form
        </Link>
        . If you ask a question we hear a lot, we&apos;ll add it here.
      </>
    ),
  },
]

export const FaqScreen = () => {
  useDocumentTitle("FAQ")

  return (
    <>
      <SiteHeader />
      <main className="mx-auto max-w-2xl px-4 py-8 sm:py-14">
        <header>
          <h1 className="text-3xl font-semibold">Frequently asked questions</h1>
          <p className="mt-2 text-gray-600">
            Don&apos;t see your question?{" "}
            <Link to={contactPath({})} className="text-blue-600 underline">
              Send us a note
            </Link>
            .
          </p>
        </header>

        <dl className="mt-8 divide-y border-t">
          {FAQS.map((item) => (
            <div key={item.q} className="py-5">
              <dt className="font-medium">{item.q}</dt>
              <dd className="mt-2 text-sm text-gray-700">{item.a}</dd>
            </div>
          ))}
        </dl>
      </main>
    </>
  )
}
